'use strict';

import packageVersion from '../../package.json';

export default {
  packageVersion: packageVersion.version,
  auth0: {
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientSecret: import.meta.env.VITE_AUTH0_CLIENT_SECRET,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  },
  google: {
    secret: import.meta.env.VITE_APP_SECRET_GOOGLE,
  },
  api: {
    domain: import.meta.env.VITE_APP_API_DOMAIN,
    bucketName: import.meta.env.VITE_APP_BUCKET_NAME,
    socketKey: import.meta.env.VITE_APP_SOCKET_KEY,
    socketApi: import.meta.env.VITE_APP_SOCKET_API,
    idGroup: import.meta.env.VITE_APP_ID_GROUP,
  },
  apiKeys: {
    partners: import.meta.env.VITE_APP_API_KEY_PARTNERS,
    plates: import.meta.env.VITE_APP_SYSTEM_DRIVERS,
    tripResume: import.meta.env.VITE_APP_MAP_CLIP_SERVICE,
    platesOnboard: import.meta.env.VITE_ONBOARD_API_KEY,
    // addressValidation: import.meta.env.VITE_APP_API_KEY_ADDRESS_VALIDATION,
  },
  templates: {
    employees: {
      createCsv: `${import.meta.env.VITE_S3_ASSETS}/importar_empleados.csv`,
      deleteCsv: `${import.meta.env.VITE_S3_ASSETS}/eliminar_empleados.csv`,
      activeCsv: `${import.meta.env.VITE_S3_ASSETS}/activar_empleados.csv`,
      inactiveCsv: `${import.meta.env.VITE_S3_ASSETS}/desactivar_empleados.csv`,
      createXlsx: `${import.meta.env.VITE_S3_ASSETS}/importar_empleados.xlsx`,
      deleteXlsx: `${import.meta.env.VITE_S3_ASSETS}/eliminar_empleados.xlsx`,
      activeXlsx: `${import.meta.env.VITE_S3_ASSETS}/activar_empleados.xlsx`,
      inactiveXlsx: `${import.meta.env.VITE_S3_ASSETS}/desactivar_empleados.xlsx`,
    },
  },
  services: {
    tokenTraccar: import.meta.env.VITE_TOKEN_TRACCAR,
    domainTraccar: import.meta.env.VITE_DOMAIN_TRACCAR,
    timeSlots: import.meta.env.VITE_APP_TIME_SLOTS_SERVICE || "20",
    days: import.meta.env.VITE_APP_DAYS_SERVICE,
    mapClip: import.meta.env.VITE_APP_MAP_CLIP_SERVICE,
    supersetHOST: import.meta.env.VITE_SUPERSET_HOST,
    supersetUSER: import.meta.env.VITE_SUPERSET_USER,
    supersetPASS: import.meta.env.VITE_SUPERSET_PASS,
    supersetDASHCLIENT: import.meta.env.VITE_SUPERSET_DASHBOARD_CLIENT,
    supersetDASHADMIN: import.meta.env.VITE_SUPERSET_DASHBOARD_ADMIN,
    metabaseHOST: import.meta.env.VITE_METABASE_HOST,
    metabaseDASHBOARD: import.meta.env.VITE_METABASE_DASHBOARD,
    metabaseCUSTOMERDASHBOARD: import.meta.env.VITE_METABASE_CUSTOMER_DASHBOARD_ID,
    metabaseROMBODASHBOARD: import.meta.env.VITE_METABASE_ROMBO_DASHBOARD_ID,
  },
  sentry: {
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  },  
};
